export default __webpack_public_path__ + "static/media/progressMeter.4c8e709d.svg";